var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "asignacionNoSeriado",
      staticStyle: { "margin-top": "50px" }
    },
    [
      _c("div", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: _vm.showForm,
            expression: "showForm"
          }
        ],
        staticClass: "flex sm10 md10"
      }),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                "text-center": "",
                layout: "",
                wrap: ""
              }
            },
            [
              _c(
                "v-flex",
                { attrs: { xs12: "", sm4: "", md4: "" } },
                [
                  _c("v-text-field", {
                    staticStyle: { "margin-left": "15px" },
                    attrs: { label: "Buscar..." },
                    on: { input: _vm.searchData },
                    model: {
                      value: _vm.filtrobusquedagrilla,
                      callback: function($$v) {
                        _vm.filtrobusquedagrilla = $$v
                      },
                      expression: "filtrobusquedagrilla"
                    }
                  })
                ],
                1
              ),
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm2: "",
                    md2: "",
                    right: "",
                    "offset-sm6": "",
                    "offset-md6": ""
                  }
                },
                [
                  _c(
                    "v-layout",
                    {
                      staticStyle: {
                        "padding-top": "20px",
                        "padding-right": "5px"
                      },
                      attrs: { "justify-end": "" }
                    },
                    [
                      _c(
                        "v-btn",
                        {
                          attrs: {
                            flat: "",
                            small: "",
                            "data-permiso": "Exportar",
                            color: "primary"
                          },
                          on: { click: _vm.descargar }
                        },
                        [
                          _c("v-icon", { staticClass: "icon" }, [
                            _vm._v("cloud_download")
                          ]),
                          _vm._v("  \n            "),
                          _c("span", { staticClass: "text" }, [
                            _vm._v("Exportar")
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "div",
            {
              staticClass: "NoSeriados scroll",
              class: { ocultar_acciones: _vm.deshabilitar }
            },
            [
              _c("MantenedorGridSinCodigo", {
                attrs: {
                  "grid-options": _vm.gridOptions,
                  "funcionalidad-id": _vm.funcionalidad
                }
              })
            ],
            1
          )
        ],
        1
      ),
      _c(
        "div",
        { staticClass: "gridcard rounded-card" },
        [
          _c(
            "v-flex",
            {
              attrs: {
                xs12: "",
                sm12: "",
                md12: "",
                "text-center": "",
                layout: "",
                wrap: ""
              }
            },
            [
              _c(
                "v-flex",
                {
                  attrs: {
                    xs12: "",
                    sm2: "",
                    md2: "",
                    right: "",
                    "offset-sm11": "",
                    "offset-md11": ""
                  }
                },
                [
                  _c(
                    "v-flex",
                    { attrs: { xs12: "", sm4: "", md4: "" } },
                    [
                      _c(
                        "v-layout",
                        {
                          staticStyle: {
                            "padding-top": "20px",
                            "padding-right": "5px"
                          },
                          attrs: { "justify-end": "" }
                        },
                        [
                          _c(
                            "v-btn",
                            {
                              attrs: {
                                flat: "",
                                small: "",
                                "data-permiso": "Exportar",
                                color: "primary"
                              },
                              on: { click: _vm.descargarResumen }
                            },
                            [
                              _c("v-icon", { staticClass: "icon" }, [
                                _vm._v("cloud_download")
                              ]),
                              _vm._v("  \n              "),
                              _c("span", { staticClass: "text" }, [
                                _vm._v("Exportar")
                              ])
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c("v-flex", { attrs: { xs12: "", sm5: "", md5: "" } }, [
            _c(
              "div",
              {
                staticClass: "NoSeriados",
                class: { ocultar_acciones: _vm.deshabilitar }
              },
              [
                _c("MantenedorGridSinCodigo", {
                  attrs: {
                    "grid-options": _vm.gridOptionsResumen,
                    "funcionalidad-id": _vm.funcionalidad
                  }
                })
              ],
              1
            )
          ])
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }